(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("bamboraCustomCheckout", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/storefront/paymentMethod/bamboraCustomCheckoutView.html",
            controller: ["tenantPaymentMethodResource", "messageService", BamboraCustomCheckoutCtrl],
            controllerAs: "vm"
        };
        function BamboraCustomCheckoutCtrl(tenantPaymentMethodResource, messageService) {
            var vm = this;
            vm.loading = true;
            tenantPaymentMethodResource.getBamboraCustomCheckoutViewModel(function (model) {
                vm.model = model;
                vm.loading = false;
            });
            vm.save = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    vm.saving = true;
                    tenantPaymentMethodResource.updateBamboraCustomCheckout(vm.model, function () {
                        messageService.success("common.changesSaved");
                        vm.saving = false;
                    }, function (error) {
                        messageService.error(error);
                        vm.saving = false;
                    });
                }
                else
                    vm.showErrors = true;
            };
        }
    });
})();
